import { AUTO_SSL_STATUS } from '@/enums/sites/status.enum';
import { SitesActionTypes } from './sites.types';

export const initialState = {
  failedWhoIsAttempt: false,
  forceReloadPropagationData: false,
  loading: false,
  plansLoading: false,
  plansLoaded: false,
  loadingExclusion: false,
  loadingDomains: false,
  loadedDomains: false,
  loadingSites: false,
  loadingHostingSites: false,
  hostingSitesLoaded: false,
  hostingSitesList: [],
  loadingDomainValidation: false,
  loadingRedirect: false,
  redirectStatus: null,
  loadedSites: false,
  anotherDomain: null,
  domainAvailability: undefined,
  domainTldAvailability: false,
  domainLinkedToPlan: false,
  list: [],
  sitesLoaded: false,
  tlds: [],
  loadingTlds: false,
  domainList: [],
  domainData: {},
  siteBuilderToolsLoading: false,
  plans: [],
  domainDnsLoading: false,
  domainDns: null,
  domainDnsChanged: false,
  planDnsLoading: false,
  planDns: null,
  wordpressLoading: false,
  wordpressLoaded: false,
  wordPressInstalled: false,
  wordPressFtpMigration: {
    loading: false,
    status: null,
  },
  wordPressFilesMigration: {
    loading: false,
    finished: false,
  },
  wordpressSso: {
    loading: false,
    status: null,
    ssoUrl: null,
    siteId: null,
  },
  questionsAnswered: { ids: [], answers: {} },
  hasSiteBuilderActive: null,
  hostingAlreadyHasWooPremium: null,
  redirectFromPreChat: false,
  loadingVerifyIfSiteExist: false,
  siteExistVerifyFinished: null,
  needToExcludeDefaultFiles: null,
  loadingDefaultFilesExclude: false,
  currentlyInstallInfo: {
    showOverwriteModal: null,
    sharedDocumentRoot: null,
    onlyDefaultFiles: null,
    siteType: null,
    siteId: null,
  },
  loadingUninstall: false,
  uninstallCompleted: false,
  uninstallError: false,
  domainDnsStatus: null,
  allDomainsDnsStatus: [],
  loadingAllDomainsDnsStatus: false,
  ssl: {
    status: null,
    callLoop: 0,
  },
  sslVerification: {
    loading: false,
    status: null,
  },
  sslConfigureDomain: {
    status: null,
    loading: false,
  },
  sitebuilder: {
    sso: {
      builderAddonId: null,
      domain: null,
      url: null,
      loading: false,
      status: null,
    },
    createSite: {
      loading: false,
      status: null,
    },
    createPreview: {
      loading: false,
      status: null,
      url: null,
    },
  },
  gatorResolve: {
    loading: false,
    completed: false,
  },
  agentsFactory: {
    account: null,
    showLoadingError: false,
    loading: false,
  },
  businessProfile: {
    loading: false,
    status: null,
  },
  domainsWithSitesCreated: [],
  loadingDomainsWithSitesCreated: false,
};

const sitesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SitesActionTypes.SET_DOMAINS_WITH_AI_SITES_CREATED: {
      return {
        ...state,
        domainsWithSitesCreated: action.payload || [],
      };
    }
    case SitesActionTypes.LOADING_DOMAINS_WITH_AI_SITES_CREATED: {
      return {
        ...state,
        loadingDomainsWithSitesCreated: action.payload,
      };
    }
    case SitesActionTypes.SITES_FROM_PRECHAT: {
      return {
        ...state,
        redirectFromPreChat: action.payload,
      };
    }
    case SitesActionTypes.GET_DOMAIN_DNS_SUCCESS: {
      return {
        ...state,
        redirectStatus: 'success',
      };
    }
    case SitesActionTypes.GET_DOMAIN_DNS_FAILURE: {
      return {
        ...state,
        redirectStatus: 'failure',
        failedWhoIsAttempt: true,
      };
    }
    case SitesActionTypes.SET_DOMAIN_DNS_CHANGED: {
      return {
        ...state,
        domainDnsChanged: action.payload.domainDnsChanged,
      };
    }
    case SitesActionTypes.RESET_DOMAIN_DNS_STATUS: {
      return {
        ...state,
        redirectStatus: null,
        domainDns: null,
      };
    }
    case SitesActionTypes.SET_LOADING_REDIRECT: {
      return {
        ...state,
        loadingRedirect: action.payload.domain,
      };
    }
    case SitesActionTypes.FORCE_RELOAD: {
      return {
        ...state,
        forceReloadPropagationData: action.payload,
      };
    }
    case SitesActionTypes.SET_LOADING: {
      const { isLoading } = action.payload;
      return {
        ...state,
        loading: isLoading,
        failedWhoIsAttempt: isLoading ? false : state.failedWhoIsAttempt,
      };
    }
    case SitesActionTypes.SET_LOADING_EXCLUSION: {
      const { isLoading } = action.payload;
      return {
        ...state,
        loadingExclusion: isLoading,
      };
    }
    case SitesActionTypes.SET_LOADING_TLDS: {
      const { isLoading } = action.payload;
      return {
        ...state,
        loadingTlds: isLoading,
      };
    }
    case SitesActionTypes.SET_LOADING_DOMAINS: {
      const { isLoading } = action.payload;
      return {
        ...state,
        loadingDomains: isLoading,
        loadedDomains: !isLoading,
      };
    }
    case SitesActionTypes.SET_LOADING_PLANS: {
      const { isLoading } = action.payload;
      return {
        ...state,
        plansLoading: isLoading,
        plansLoaded: !isLoading,
      };
    }
    case SitesActionTypes.SET_LOADING_SITES: {
      const { isLoading } = action.payload;
      return {
        ...state,
        loadingSites: isLoading,
        loadedSites: !isLoading,
      };
    }
    case SitesActionTypes.SET_LOADING_HOSTING_SITES: {
      const { isLoading } = action.payload;
      return {
        ...state,
        loadingHostingSites: isLoading,
      };
    }
    case SitesActionTypes.SET_HOSTING_SITES: {
      const { hostingSites } = action.payload;
      return {
        ...state,
        hostingSitesList: hostingSites,
        hostingSitesLoaded: true,
      };
    }
    case SitesActionTypes.SET_LOADING_DOMAIN_VALIDATION: {
      return {
        ...state,
        loadingDomainValidation: action.payload.isLoading,
      };
    }
    case SitesActionTypes.SET_SITES: {
      const { sites } = action.payload;
      return {
        ...state,
        list: sites,
        sitesLoaded: true,
      };
    }
    case SitesActionTypes.LOADING_GATOR_RESOLVE_FORM: {
      const isLoading = action.payload;
      return {
        ...state,
        gatorResolve: {
          ...state.gatorResolve,
          loading: isLoading,
        },
      };
    }
    case SitesActionTypes.SUCCESS_GATOR_RESOLVE_FORM: {
      return {
        ...state,
        gatorResolve: {
          ...state.gatorResolve,
          completed: true,
        },
      };
    }
    case SitesActionTypes.RESET_GATOR_RESOLVE_FORM: {
      return {
        ...state,
        gatorResolve: {
          ...initialState.gatorResolve,
        },
      };
    }
    case SitesActionTypes.SET_SITES_DOMAINS: {
      const { domains } = action.payload;
      return {
        ...state,
        domainList: domains,
      };
    }
    case SitesActionTypes.SET_SITE_BUILDER_TOOLS: {
      const { domainData } = action.payload;
      return {
        ...state,
        domainData,
      };
    }

    case SitesActionTypes.LOAD_SITE_BUILDER_TOOLS: {
      return {
        ...state,
        siteBuilderToolsLoading: action.payload,
      };
    }

    case SitesActionTypes.SET_TLDS: {
      const { tlds } = action.payload;
      return {
        ...state,
        tlds,
      };
    }
    case SitesActionTypes.SET_DOMAIN_AVAILABILITY: {
      const {
        domainAvailability,
        domainTldAvailability,
        domain,
        domainAndSubdomain,
      } = action.payload;
      return {
        ...state,
        anotherDomain: domain,
        domainAvailability,
        domainTldAvailability,
        domainAndSubdomain,
      };
    }
    case SitesActionTypes.SET_ADITIONAL_DOMAIN_LINKED_TO_PLAN: {
      const { domainLinkedToPlan } = action.payload;
      return {
        ...state,
        domainLinkedToPlan,
      };
    }
    case SitesActionTypes.SET_PLANS: {
      const { plans } = action.payload;
      return {
        ...state,
        plans,
      };
    }
    case SitesActionTypes.SET_DOMAIN_DNS_LOADING: {
      const { isLoading } = action.payload;
      return {
        ...state,
        domainDnsLoading: isLoading,
      };
    }
    case SitesActionTypes.SET_DOMAIN_DNS: {
      const { domainDns } = action.payload;
      return {
        ...state,
        domainDns,
        failedWhoIsAttempt: false,
      };
    }
    case SitesActionTypes.SET_PLAN_DNS_LOADING: {
      const { isLoading } = action.payload;
      return {
        ...state,
        planDnsLoading: isLoading,
      };
    }
    case SitesActionTypes.RESET_PLAN_DNS: {
      return {
        ...state,
        planDns: null,
      };
    }
    case SitesActionTypes.SET_PLAN_DNS: {
      const { planDns } = action.payload;
      return {
        ...state,
        planDns,
      };
    }
    case SitesActionTypes.SET_WORDPRESS_INSTALLATION_LOADING: {
      const { isLoading } = action.payload;
      return {
        ...state,
        wordpressLoading: isLoading,
        wordpressLoaded: !isLoading,
      };
    }
    case SitesActionTypes.SET_WORDPRESS_INSTALLATION_STATUS: {
      const { installed } = action.payload;
      return {
        ...state,
        wordPressInstalled: installed,
      };
    }
    case SitesActionTypes.SET_WORDPRESS_INSTALLATION_SUCCESS: {
      const { ssoUrl, siteId } = action.payload;
      return {
        ...state,
        wordpressSso: {
          ...state.wordpressSso,
          ssoUrl,
          siteId,
        },
      };
    }
    case SitesActionTypes.SET_WORDPRESS_INSTALLATION_DEFAULT: {
      return {
        ...state,
        wordpressLoaded: false,
        wordPressInstalled: false,
      };
    }
    case SitesActionTypes.SET_WORDPRESS_FTP_MIGRATION_SUCCESS: {
      return {
        ...state,
        wordPressFtpMigration: {
          ...state.wordPressFtpMigration,
          status: 'success',
        },
      };
    }
    case SitesActionTypes.SET_WORDPRESS_FTP_MIGRATION_FAILURE: {
      return {
        ...state,
        wordPressFtpMigration: {
          ...state.wordPressFtpMigration,
          status: 'failure',
        },
      };
    }
    case SitesActionTypes.SET_WORDPRESS_FTP_MIGRATION_LOADING: {
      const { isLoading } = action.payload;
      return {
        ...state,
        wordPressFtpMigration: {
          ...state.wordPressFtpMigration,
          loading: isLoading,
        },
      };
    }
    case SitesActionTypes.SET_WORDPRESS_FTP_MIGRATION_RESET: {
      return {
        ...state,
        wordPressFtpMigration: {
          ...state.wordPressFtpMigration,
          status: null,
          loading: false,
        },
      };
    }
    case SitesActionTypes.SET_WORDPRESS_FILES_MIGRATION_LOADING: {
      return {
        ...state,
        wordPressFilesMigration: {
          loading: action.payload.bool,
        },
      };
    }
    case SitesActionTypes.WP_SUCCESSFULLY_REQUESTED_INSTALATION: {
      return {
        ...state,
        wordPressFilesMigration: {
          ...state.wordPressFilesMigration,
          finished: action.payload,
        },
      };
    }
    case SitesActionTypes.SET_WORDPRESS_SSO_LOADING: {
      const { isLoading } = action.payload;
      return {
        ...state,
        wordpressSso: {
          ...state.wordpressSso,
          loading: isLoading,
        },
      };
    }
    case SitesActionTypes.SET_WORDPRESS_SSO: {
      const { ssoUrl } = action.payload;
      return {
        ...state,
        wordpressSso: {
          ...state.wordpressSso,
          ssoUrl,
        },
      };
    }
    case SitesActionTypes.SET_WORDPRESS_SSO_SUCCESS: {
      return {
        ...state,
        wordpressSso: {
          ...state.wordpressSso,
          status: 'success',
        },
      };
    }
    case SitesActionTypes.SET_WORDPRESS_SSO_FAILURE: {
      return {
        ...state,
        wordpressSso: {
          ...state.wordpressSso,
          status: 'failure',
        },
      };
    }
    case SitesActionTypes.SET_SURVEY_QUESTIONS_ANSWERED: {
      const { questions } = action.payload;
      return {
        ...state,
        questionsAnswered: questions,
      };
    }
    case SitesActionTypes.SET_SITE_BUILDER_ACTIVE: {
      const { hasSiteBuilderActive } = action.payload;
      return {
        ...state,
        hasSiteBuilderActive,
      };
    }
    case SitesActionTypes.GET_ADDON_CHECK_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        hostingAlreadyHasWooPremium: data,
      };
    }
    case SitesActionTypes.SET_ADDON_CHECK_DEFAULT: {
      return {
        ...state,
        hostingAlreadyHasWooPremium: null,
      };
    }
    case SitesActionTypes.GET_VERIFY_SITE_EXIST_LOADING: {
      const { isLoading } = action.payload;
      return {
        ...state,
        loadingVerifyIfSiteExist: isLoading,
      };
    }
    case SitesActionTypes.GET_VERIFY_SITE_EXIST_SUCCESS: {
      return {
        ...state,
        siteExistVerifyFinished: true,
        currentlyInstallInfo: action.payload,
      };
    }
    case SitesActionTypes.GET_VERIFY_SITE_EXIST_DEFAULT_FILES_EXCLUDE: {
      return {
        ...state,
        needToExcludeDefaultFiles: true,
        currentlyInstallInfo: action.payload,
        loadingDefaultFilesExclude: true,
      };
    }
    case SitesActionTypes.GET_VERIFY_SITE_EXIST_DEFAULT_FILES_EXCLUDE_SUCCESS: {
      return {
        ...state,
        needToExcludeDefaultFiles: false,
        siteExistVerifyFinished: false,
        loadingDefaultFilesExclude: false,
      };
    }
    case SitesActionTypes.GET_VERIFY_SITE_EXIST_DEFAULT_FILES_EXCLUDE_FAILURE: {
      return {
        ...state,
        needToExcludeDefaultFiles: false,
        siteExistVerifyFinished: false,
        loadingDefaultFilesExclude: false,
      };
    }
    case SitesActionTypes.GET_VERIFY_SITE_EXIST_FAILURE: {
      return {
        ...state,
        siteExistVerifyFinished: false,
        loadingDefaultFilesExclude: false,
      };
    }
    case SitesActionTypes.GET_VERIFY_SITE_EXIST_RESET: {
      return {
        ...state,
        siteExistVerifyFinished: false,
        needToExcludeDefaultFiles: null,
        loadingDefaultFilesExclude: false,
        currentlyInstallInfo: {
          showOverwriteModal: null,
          sharedDocumentRoot: null,
          onlyDefaultFiles: null,
          siteType: null,
          siteId: null,
        },
        uninstallCompleted: false,
        uninstallError: false,
      };
    }
    case SitesActionTypes.UNINSTALL_SITE_LOADING: {
      const { isLoading } = action.payload;
      return {
        ...state,
        loadingUninstall: isLoading,
      };
    }
    case SitesActionTypes.UNINSTALL_SITE_SUCCESS: {
      return {
        ...state,
        uninstallCompleted: true,
        uninstallError: false,
      };
    }
    case SitesActionTypes.UNINSTALL_SITE_FAILURE: {
      return {
        ...state,
        uninstallCompleted: false,
        uninstallError: true,
      };
    }
    case SitesActionTypes.GET_DOMAIN_DNS_STATUS_CHECK_SUCCESS: {
      const status = action.payload;
      return {
        ...state,
        domainDnsStatus: status,
      };
    }
    case SitesActionTypes.GET_DOMAIN_DNS_STATUS_CHECK_FAILURE: {
      return {
        ...state,
        domainDnsStatus: null,
      };
    }
    case SitesActionTypes.GET_ALL_DOMAINS_DNS_STATUS_CHECK_SUCCESS: {
      const status = action.payload;
      return {
        ...state,
        allDomainsDnsStatus: status,
      };
    }
    case SitesActionTypes.GET_ALL_DOMAINS_DNS_STATUS_CHECK_LOADING: {
      const { isLoading } = action.payload;
      return {
        ...state,
        loadingAllDomainsDnsStatus: isLoading,
      };
    }
    case SitesActionTypes.CLEAR_SSL_STATUS: {
      return {
        ...state,
        ssl: {
          ...state.ssl,
          status: null,
          callLoop: 0,
        },
        sslVerification: {
          ...state.sslVerification,
          status: null,
        },
        sslConfigureDomain: {
          ...state.sslConfigureDomain,
          status: null,
        },
      };
    }
    case SitesActionTypes.AUTO_SSL_START_SUCCESS: {
      return {
        ...state,
        ssl: {
          ...state.ssl,
          status: AUTO_SSL_STATUS.START_SUCCESS,
        },
      };
    }
    case SitesActionTypes.AUTO_SSL_START_FAILURE: {
      return {
        ...state,
        ssl: {
          ...state.ssl,
          status: AUTO_SSL_STATUS.START_FAILURE,
        },
      };
    }
    case SitesActionTypes.AUTO_SSL_PROGRESS_LOOP: {
      return {
        ...state,
        ssl: {
          ...state.ssl,
          callLoop: action.payload.callLoop,
        },
      };
    }
    case SitesActionTypes.AUTO_SSL_PROGRESS_FAILURE: {
      return {
        ...state,
        ssl: {
          ...state.ssl,
          status: AUTO_SSL_STATUS.PROGRESS_FAILURE,
        },
      };
    }
    case SitesActionTypes.AUTO_SSL_CHECK_SUCCESS: {
      return {
        ...state,
        ssl: {
          ...state.ssl,
          status: AUTO_SSL_STATUS.CHECK_SUCCESS,
        },
      };
    }
    case SitesActionTypes.AUTO_SSL_CHECK_FAILURE: {
      return {
        ...state,
        ssl: {
          ...state.ssl,
          status: AUTO_SSL_STATUS.CHECK_FAILURE,
        },
      };
    }
    case SitesActionTypes.SET_LOADING_SSL_VERIFICATION: {
      return {
        ...state,
        sslVerification: {
          ...state.sslVerification,
          loading: action.payload.isLoading,
        },
      };
    }
    case SitesActionTypes.SET_SSL_VERIFICATION: {
      return {
        ...state,
        sslVerification: {
          ...state.sslVerification,
          status: action.payload,
        },
      };
    }
    case SitesActionTypes.POST_DOMAIN_TO_HG_LOADING: {
      return {
        ...state,
        sslConfigureDomain: {
          ...state.sslConfigureDomain,
          loading: action.payload.isLoading,
        },
      };
    }
    case SitesActionTypes.POST_DOMAIN_TO_HG_SUCCESS: {
      return {
        ...state,
        sslConfigureDomain: {
          ...state.sslConfigureDomain,
          status: 'success',
        },
      };
    }
    case SitesActionTypes.POST_DOMAIN_TO_HG_FAILURE: {
      return {
        ...state,
        sslConfigureDomain: {
          ...state.sslConfigureDomain,
          status: 'error',
        },
      };
    }
    case SitesActionTypes.SET_CREATE_SITE_WITH_BUILDER_LOADING: {
      const { isLoading } = action.payload;
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          createSite: {
            ...state.sitebuilder.createSite,
            loading: isLoading,
          },
        },
      };
    }
    case SitesActionTypes.SET_CREATE_SITE_WITH_BUILDER: {
      const { builderAddonId, domain, url } = action.payload;

      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,

          createSite: {
            ...state.sitebuilder.createSite,
            status: 'success',
          },
          sso: {
            ...state.sitebuilder.sso,
            builderAddonId,
            domain,
            url,
          },
        },
      };
    }
    case SitesActionTypes.CREATE_SITE_WITH_BUILDER_FAILURE: {
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          createSite: {
            ...state.sitebuilder.createSite,
            status: 'failure',
          },
        },
      };
    }
    case SitesActionTypes.RESET_CREATE_SITE_WITH_BUILDER: {
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          createSite: {
            ...initialState.sitebuilder.createSite,
          },
        },
      };
    }
    case SitesActionTypes.SET_BUILDER_SSO_LOADING: {
      const { isLoading } = action.payload;
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          sso: {
            ...state.sitebuilder.sso,
            loading: isLoading,
          },
        },
      };
    }
    case SitesActionTypes.SET_BUILDER_SSO: {
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,

          sso: {
            ...state.sitebuilder.sso,
            builderAddonId: action.payload.builderAddonId,
            domain: action.payload.domain,
            url: action.payload.url,
            status: 'success',
          },
        },
      };
    }
    case SitesActionTypes.SET_BUILDER_SSO_FAILURE: {
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          sso: {
            ...state.sitebuilder.sso,
            status: 'failure',
          },
        },
      };
    }
    case SitesActionTypes.SET_BUILDER_SSO_SUCCESS: {
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          sso: {
            ...state.sitebuilder.sso,
            status: 'success',
          },
        },
      };
    }
    case SitesActionTypes.AGENTS_FACTORY_CHECK_AVAILABILITY_LOADING: {
      return {
        ...state,
        agentsFactory: {
          ...state.agentsFactory,
          loading: action.payload,
        },
      };
    }
    case SitesActionTypes.AGENTS_FACTORY_CHECK_AVAILABILITY_SET: {
      const {
        agentsFactory,
      } = action.payload;
      return {
        ...state,
        agentsFactory: {
          ...state.agentsFactory,
          account: agentsFactory,
        },
      };
    }
    case SitesActionTypes.AGENTS_FACTORY_CHECK_AVAILABILITY_FAILURE: {
      return {
        ...state,
        agentsFactory: {
          ...state.agentsFactory,
          showLoadingError: true,
        },
      };
    }
    case SitesActionTypes.AGENTS_FACTORY_CHECK_AVAILABILITY_REQUEST: {
      return {
        ...state,
        agentsFactory: {
          ...state.agentsFactory,
          showLoadingError: false,
        },
      };
    }
    case SitesActionTypes.CREATE_BUSINESS_PROFILE_LOADING: {
      return {
        ...state,
        businessProfile: {
          ...state.businessProfile,
          loading: action.payload,
        },
      };
    }
    case SitesActionTypes.CREATE_BUSINESS_PROFILE_SUCCESS: {
      return {
        ...state,
        businessProfile: {
          ...state.businessProfile,
          status: 'success',
        },
      };
    }
    case SitesActionTypes.CREATE_BUSINESS_PROFILE_FAILURE: {
      return {
        ...state,
        businessProfile: {
          ...state.businessProfile,
          status: 'failure',
        },
      };
    }
    case SitesActionTypes.SET_CREATE_PREVIEW_WITH_BUILDER_LOADING: {
      const { isLoading } = action.payload;
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          createPreview: {
            ...state.sitebuilder.createPreview,
            loading: isLoading,
          },
        },
      };
    }
    case SitesActionTypes.SET_CREATE_PREVIEW_WITH_BUILDER: {
      const { projectUid } = action.payload;
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          createPreview: {
            ...state.sitebuilder.createPreview,
            projectUid,
            status: 'success',
          },
        },
      };
    }
    case SitesActionTypes.CREATE_PREVIEW_WITH_BUILDER_FAILURE: {
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          createPreview: {
            ...state.sitebuilder.createPreview,
            status: 'failure',
          },
        },
      };
    }
    case SitesActionTypes.RESET_CREATE_PREVIEW_WITH_BUILDER: {
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          createPreview: {
            ...initialState.sitebuilder.createPreview,
          },
        },
      };
    }
    default:
      return state;
  }
};

export default sitesReducer;
